(function () {
  var DESKTOP_MQ = '(min-width: 641px)';
  var instances = new WeakMap();

  function parseSlides(value, fallback) {
    var parsed = parseFloat(value);
    if (isNaN(parsed) || parsed <= 0) return fallback;
    return parsed;
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function getDesktopSlides(root) {
    return parseSlides(root.getAttribute('data-desktop-slides'), 2.5);
  }

  function getMobileSlides(root) {
    return parseSlides(root.getAttribute('data-mobile-slides'), 1.25);
  }

  function getSlideCount(root) {
    return root.querySelectorAll('.swiper-slide').length;
  }

  function getActiveSlidesPerView(root) {
    return isDesktop() ? getDesktopSlides(root) : getMobileSlides(root);
  }

  function needsCarousel(root) {
    return getSlideCount(root) > getActiveSlidesPerView(root);
  }

  function setStaticGrid(root) {
    root.classList.add('is-static-grid');
    root.classList.remove('is-carousel');
    root.style.setProperty('--ru-sc-cols', String(getSlideCount(root) || 1));
  }

  function destroySwiper(root) {
    var swiper = instances.get(root);
    if (swiper && typeof swiper.destroy === 'function') {
      swiper.destroy(true, true);
    }
    instances.delete(root);
  }

  function initSwiper(root) {
    if (typeof Swiper === 'undefined') {
      console.warn('[RuSiluetasCategorias] Swiper is not loaded');
      return;
    }

    if (instances.get(root)) return;

    root.classList.remove('is-static-grid');
    root.classList.add('is-carousel');

    var useCssMode = !isDesktop();

    var swiper = new Swiper(root, {
      slidesPerView: getMobileSlides(root),
      spaceBetween: 0,
      cssMode: useCssMode,
      speed: useCssMode ? 0 : 450,
      resistanceRatio: 0.85,
      watchOverflow: true,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: false,
        momentum: !useCssMode,
        momentumBounce: false,
        momentumRatio: 1,
        momentumVelocityRatio: 1
      },
      breakpoints: {
        641: {
          slidesPerView: getDesktopSlides(root)
        }
      }
    });

    swiper.__ruCssMode = useCssMode;
    instances.set(root, swiper);
  }

  function syncSection(root) {
    if (!root) return;

    var existing = instances.get(root);
    var shouldCarousel = needsCarousel(root);

    if (!shouldCarousel) {
      destroySwiper(root);
      setStaticGrid(root);
      return;
    }

    if (existing) {
      var mobile = getMobileSlides(root);
      var desktop = getDesktopSlides(root);
      var wantCssMode = !isDesktop();
      var modeChanged = existing.__ruCssMode !== wantCssMode;
      var changed =
        modeChanged ||
        existing.params.slidesPerView !== mobile ||
        (existing.params.breakpoints &&
          existing.params.breakpoints[641] &&
          existing.params.breakpoints[641].slidesPerView !== desktop);

      if (changed) {
        destroySwiper(root);
        initSwiper(root);
      } else {
        existing.update();
      }
      return;
    }

    initSwiper(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ru-siluetas-categorias]');
    roots.forEach(syncSection);
  }

  var resizeTimer;
  function debouncedResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initAll(document);
    }, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  window.addEventListener('resize', debouncedResize);
  window.addEventListener('orientationchange', debouncedResize);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-ru-siluetas-categorias]');
    if (root) destroySwiper(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target && event.target.closest('[data-ru-siluetas-categorias]');
    if (!root) return;
    var swiper = instances.get(root);
    if (!swiper) return;
    var slide = event.target.closest('.swiper-slide');
    if (!slide || !slide.parentNode) return;
    var index = Array.prototype.indexOf.call(slide.parentNode.children, slide);
    if (index >= 0) swiper.slideTo(index);
  });
})();
